// extracted by mini-css-extract-plugin
export var lg = "_1k-4";
export var md = "_1k-3";
export var sm = "_1k-2";
export var xs = "_1k-1";
export var xxs = "_1k-0";